export default __webpack_public_path__ + "static/media/edit.22ac3be5.svg";